<template>
    <ul class="pagination">
        <li class="page-item" :class="{'disabled': currentPage <= 1}">
            <button class="page-link" :disabled="currentPage <= 1" @click="prevPage()">🠄</button>
        </li>
        <li class="page-splitter">
            <input type="number" v-model="page" @keyup.enter="setPage()">
            <span> / {{maxPage}}</span>
        </li>
        <li class="page-item" :class="{'disabled': maxPage <= currentPage}">
            <button class="page-link" :disabled="maxPage <= currentPage" @click="nextPage()">🠆</button>
        </li>
    </ul>
</template>

<script>
    export default {
        data() {
            return {
                page: this.$route.params.page
            }
        },
        props: ['current-page', 'max-page', 'filter'],
        methods: {
            prevPage() {
                let filter = this.filter;
                let page = parseInt(this.$route.params.page);
                this.$router.push({name: this.$route.name, params: {page: page - 1, filter}})
            },
            nextPage() {
                let filter = this.filter;
                let page = parseInt(this.$route.params.page);
                this.$router.push({name: this.$route.name, params: {page: page + 1, filter}})
            },
            setPage() {
                let filter = this.filter;
                this.$router.push({name: this.$route.name, params: {page: this.page, filter}})
            }
        }
    }
</script>

<style lang="scss" scoped>
    .pagination {
        display: flex;
        border-radius: .25rem;

        li {
            &:first-child button {
                border-top-left-radius: .25rem;
                border-bottom-left-radius: .25rem;
            }

            &:last-child button {
                border-top-right-radius: .25rem;
                border-bottom-right-radius: .25rem;
            }

            button {
                color: #fff;
                background: #262a2d;
                border: 1px solid #262a2d;
                display: block;
                padding: .5rem .75rem;
                line-height: 1.25;
                outline: none;
                cursor: pointer;
                font-size: inherit;
                border-radius: 0;
            }

            &.page-splitter {
                background: #262a2d;
                border: 1px solid #262a2d;
                color: #6c757d;
                cursor: auto;
                display: block;
                padding: .5rem .75rem .49rem .75rem;
                border-radius: 0;

                input {
                    font-size: 1rem;
                    text-align: right;
                    width: 28px;
                    color: #6c757d;
                    background-color: transparent;
                    border: none;
                    outline: none;

                    &::-webkit-outer-spin-button,
                    &::-webkit-inner-spin-button {
                        -webkit-appearance: none;
                        margin: 0;
                    }

                    &[type=number] {
                        -moz-appearance: textfield;
                    }
                }
            }

            &.disabled button {
                color: #777;
                background: #262a2d !important;
                cursor: not-allowed;
            }
        }
    }
</style>